var config = {
  apiKey: "AIzaSyBq46sT2sAfDg4uPgtIFQiA384oYB7E6MU",
  authDomain: "tree-of-fullfillment.firebaseapp.com",
  databaseURL: "https://tree-of-fullfillment.firebaseio.com",
  projectId: "tree-of-fullfillment",
  storageBucket: "tree-of-fullfillment.appspot.com",
  messagingSenderId: "797700803366"
};

export default config;